"use client";

import type { CSSProperties, ReactNode } from 'react';
import { Tip } from '@/shared/components/ui/tooltip';
import { cn } from '@/shared/lib/utils';

type ETooltipProps = {
    label: ReactNode;
    content: ReactNode;
    ariaLabel?: string;
    triggerText?: ReactNode;
    className?: string;
    labelClassName?: string;
    labelStyle?: CSSProperties;
    triggerClassName?: string;
    delayDuration?: number;
};

export function ETooltip({
    label,
    content,
    ariaLabel,
    triggerText = '?',
    className,
    labelClassName,
    labelStyle,
    triggerClassName,
    delayDuration = 350,
}: ETooltipProps) {
    const triggerLabel = ariaLabel ?? (typeof label === 'string' ? `${label}提示` : '提示');

    return (
        <span className={cn('inline-flex items-center gap-2 font-normal text-[13px] leading-[22px] text-[#d0d0d0] not-italic', className)}>
            <span className={cn('shrink-0', labelClassName)} style={labelStyle}>
                {label}
            </span>
            <Tip content={content} delayDuration={delayDuration}>
                <button
                    type="button"
                    aria-label={triggerLabel}
                    className={cn(
                        'inline-flex h-3.5 w-3.5 items-center justify-center rounded-full border border-white/25 bg-transparent p-0 text-[12px] leading-none font-normal text-white/25 shadow-none transition hover:border-[#2D8CEB] hover:text-[#2D8CEB] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/35 focus-visible:ring-offset-0 cursor-help',
                        triggerClassName,
                    )}
                >
                    {triggerText}
                </button>
            </Tip>
        </span>
    );
}